import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';

import Login               from './pages/Login';
import Projects            from './pages/Projects';
import ProjectDashboard    from './pages/ProjectDashboard';
import DocumentLibrary     from './pages/DocumentLibrary';
import Compare             from './pages/Compare';
import ContractLog         from './pages/ContractLog';
import Suppliers           from './pages/Suppliers';
import SupplierProfile     from './pages/SupplierProfile';
import InvoiceVerification from './pages/InvoiceVerification';
import Intelligence        from './pages/Intelligence';

function PrivateRoute({ children }) {
  const { user } = useAuth();
  return user ? children : <Navigate to="/login" replace />;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />

      <Route path="/" element={<PrivateRoute><Projects /></PrivateRoute>} />
      <Route path="/projects/:id" element={<PrivateRoute><ProjectDashboard /></PrivateRoute>} />
      <Route path="/projects/:id/documents" element={<PrivateRoute><DocumentLibrary /></PrivateRoute>} />
      <Route path="/projects/:id/compare" element={<PrivateRoute><Compare /></PrivateRoute>} />
      <Route path="/projects/:id/timeline" element={<PrivateRoute><ContractLog /></PrivateRoute>} />
      <Route path="/projects/:id/chat" element={<PrivateRoute><ProjectDashboard /></PrivateRoute>} />
      <Route path="/suppliers" element={<PrivateRoute><Suppliers /></PrivateRoute>} />
      <Route path="/suppliers/:id" element={<PrivateRoute><SupplierProfile /></PrivateRoute>} />
      <Route path="/intelligence" element={<PrivateRoute><Intelligence /></PrivateRoute>} />

      {/* Invoice Verification report page */}
      <Route path="/projects/:id/verifications/:vid" element={<PrivateRoute><InvoiceVerification /></PrivateRoute>} />

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}
